module.exports = __webpack_public_path__ + "static/media/eye-solid-full.b1676b01.svg";